export const rootConfig = {
  apiRoot: `http://206.189.23.252:8081/web/v1`,
  // imagesRoot: `http://206.189.23.252/wp-content/uploads`,
  imagesRoot: `https://beebom.com/wp-content/uploads`,
  itemsRequiredInRecentNews: '20',
  itemsRequiredInT3Latest: '20',
  itemsRequiredInLatestReviews: '10',
  itemsRequiredInTopNews: '4',
  itemsRequiredInTopReviews: '4',
  itemsRequiredInLaptopsMobilesCamerasAccessories: '4',
  itemsRequiredInBestOfLaptopsMobilesCamerasAccessories: '5',
  itemsRequiredInLaptopsMobilesCamerasAccessoriesReviews: '10',
  // laptops: '37320',
  // mobiles: '37321',
  // cameras: '37322',
  // accessories: '37323'
  laptops: '1211',
  mobiles: '105',
  accessories: '450',
  internet: '341',
  altrenative: '1210'
};

export const apiEndpoints = {
  bannerData: `${rootConfig.apiRoot}/posts/trend-posts/342`,
  trendingTags: `${rootConfig.apiRoot}/posts/trend-tags/342`,
  recentNews: `${rootConfig.apiRoot}/posts/feeds/category/342/${
    rootConfig.itemsRequiredInRecentNews
  }`,
  topNews: `${rootConfig.apiRoot}/posts/feeds/trend/342/${
    rootConfig.itemsRequiredInTopNews
  }`,
  increasePostCount: `${rootConfig.apiRoot}/posts/feeds/count`,
  singleNews: `${rootConfig.apiRoot}/posts/feeds`,
  relatedArticles: `${rootConfig.apiRoot}/posts/related-posts`,
  getMorePosts: `${rootConfig.apiRoot}/posts/getmore`,
  reviewsPageBanner: `${rootConfig.apiRoot}/posts/banner/104/1`,
  latestReviews: `${rootConfig.apiRoot}/posts/feeds/category/104/${
    rootConfig.itemsRequiredInLatestReviews
  }`,
  topReviews: `${rootConfig.apiRoot}/posts/feeds/top-reviews/104/${
    rootConfig.itemsRequiredInTopReviews
  }`,
  laptops: `${rootConfig.apiRoot}/posts/feeds/category/${rootConfig.laptops}/${
    rootConfig.itemsRequiredInLaptopsMobilesCamerasAccessories
  }`,
  mobiles: `${rootConfig.apiRoot}/posts/feeds/category/${rootConfig.mobiles}/${
    rootConfig.itemsRequiredInLaptopsMobilesCamerasAccessories
  }`,
  cameras: `${rootConfig.apiRoot}/posts/feeds/category/${rootConfig.cameras}/${
    rootConfig.itemsRequiredInLaptopsMobilesCamerasAccessories
  }`,
  accessories: `${rootConfig.apiRoot}/posts/feeds/category/${
    rootConfig.accessories
  }/${rootConfig.itemsRequiredInLaptopsMobilesCamerasAccessories}`,
  bestOfLaptops: `${rootConfig.apiRoot}/bestof/${rootConfig.laptops}/${
    rootConfig.itemsRequiredInBestOfLaptopsMobilesCamerasAccessories
  }`,
  bestOfMobiles: `${rootConfig.apiRoot}/bestof/${rootConfig.mobiles}/${
    rootConfig.itemsRequiredInBestOfLaptopsMobilesCamerasAccessories
  }`,
  bestOfCameras: `${rootConfig.apiRoot}/bestof/${rootConfig.cameras}/${
    rootConfig.itemsRequiredInBestOfLaptopsMobilesCamerasAccessories
  }`,
  bestOfAccessories: `${rootConfig.apiRoot}/bestof/${rootConfig.accessories}/${
    rootConfig.itemsRequiredInBestOfLaptopsMobilesCamerasAccessories
  }`,
  laptopsReviews: `${rootConfig.apiRoot}/posts/feeds/category/${
    rootConfig.laptops
  }/${rootConfig.itemsRequiredInLaptopsMobilesCamerasAccessoriesReviews}`,
  mobilesReviews: `${rootConfig.apiRoot}/posts/feeds/category/${
    rootConfig.mobiles
  }/${rootConfig.itemsRequiredInLaptopsMobilesCamerasAccessoriesReviews}`,
  camerasReviews: `${rootConfig.apiRoot}/posts/feeds/category/${
    rootConfig.cameras
  }/${rootConfig.itemsRequiredInLaptopsMobilesCamerasAccessoriesReviews}`,
  accessoriesReviews: `${rootConfig.apiRoot}/posts/feeds/category/${
    rootConfig.accessories
  }/${rootConfig.itemsRequiredInLaptopsMobilesCamerasAccessoriesReviews}`,
  singleReview: `${rootConfig.apiRoot}/posts/feeds`,

  t3BannerData: `${rootConfig.apiRoot}/posts/banner/21/2`,
  t3Latest: `${rootConfig.apiRoot}/posts/feeds/category/21/${
    rootConfig.itemsRequiredInT3Latest
  }`,
  internetBannerData: `${rootConfig.apiRoot}/posts/banner/341/2`,
  internetLatest: `${rootConfig.apiRoot}/posts/feeds/category/341/${
    rootConfig.itemsRequiredInT3Latest
  }`,

  authorData: `${rootConfig.apiRoot}/users`,
  authorPosts: `${rootConfig.apiRoot}/users/feeds`,
  tagsPostList: `${rootConfig.apiRoot}/posts/feeds/tag-posts`,
  singlePostType: `${rootConfig.apiRoot}/posts/post-category`,

  homePageBanner: `${rootConfig.apiRoot}/home/banner`,
  homeTrending: `${rootConfig.apiRoot}/posts/feeds/trend/342/5`,
  homeLatest: `${rootConfig.apiRoot}/home/news`,
  homeReviews: `${rootConfig.apiRoot}/home/reviews`,
  gallery: `${rootConfig.apiRoot}/posts/gallery`,
  oldGallery: `${rootConfig.apiRoot}/posts/old-gallery`,
  tnc: `${rootConfig.apiRoot}/page/privacy-policy`,
  contactForm: `${rootConfig.apiRoot}/form/contact_form`,
  fetchTagsList: `${rootConfig.apiRoot}/posts/feeds/tags`,
  searchInput: `${rootConfig.apiRoot}/search`
};
